import axios from "axios";

export default axios.create({
    baseURL: "https://dashapiv3.maasta.in",
    withCredentials: true,
    crossDomain: true,
});
